export const GET_CARD_TYPE_DEF= "GET_CARD_TYPE_DEF"
export const GET_CARD_TYPE_DEF_SUCCESS = "GET_CARD_TYPE_DEF_SUCCESS"
export const GET_CARD_TYPE_DEF_FAIL = "GET_CARD_TYPE_DEF_FAIL"

export const CARD_TYPE_DEF_API_ERROR = "API_ERROR"